<script>

export default {
  name: 'MyLogin',
  mounted() {
    this.$keycloak.login();
  },
}
</script>
